import { RotateCcwIcon } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui'
import { useToast } from '@/hooks'
import { useProjectMutations } from '@/modules/projects'

export const RetrySegmentButton = ({ segmentId }: { segmentId: number }) => {
  const { retryStatementSegment } = useProjectMutations()
  const { successToast, errorToast } = useToast()
  const [isRetrying, setIsRetrying] = useState(false)

  const retry = async () => {
    setIsRetrying(true)
    try {
      await retryStatementSegment(segmentId)
      successToast('Retry started')
    } catch (error) {
      errorToast('Failed to retry', error as Error)
    } finally {
      setIsRetrying(false)
    }
  }

  return (
    <Button
      theme="outline"
      size="xs"
      className="cursor-pointer gap-1.5"
      isLoading={isRetrying}
      loadingText="Retrying..."
      onClick={retry}
    >
      <RotateCcwIcon className="size-3.5" />
      Retry
    </Button>
  )
}
